/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 入口适配（参数适配、渠道适配）
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-17 20:26:56
 * @LastEditTime: 2023-11-13 16:20:37
 * @FilePath: /client-h5-v2/src/common-ts/location.ts
 */
import store from '@/store/index'
import { ElLoading, ElMessage } from 'element-plus'
import { decode } from 'js-base64'
import { LooseObject } from '@/type-declare'
import { apiGetConfigQuery } from '@/apis/config/query'
import { apiGetApplicationPropterty, apiGetLocalfiles } from '@/apis/config/applicationPropterty'
import { apiGetInitConfigQuery } from '@/apis/config/initConfigQuery'
import { InitConfigQueryParams } from '@/apis/types'
import { setCookie } from '@/common-ts/utils'
import { loginADFS } from './loginADFS'

// 获取渠道
const getChannel = (params:LooseObject): string => {
  let channel = ''
  // 动态设置channel参数
  const userAgent:string = isMobile() ? 'mobile' : 'pc'
  if (userAgent === 'mobile' && !window.location.href.includes('app')) {
    channel = 'mobile'
  } else {
    channel = 'pc'
  }

  if (window.location.href.includes('lmsa')) {
    channel = 'lmsa'
  }
  if (window.location.href.includes('forum')) {
    channel = 'fourm'
  }
  if (window.location.href.includes('app')) {
    channel = 'app'
  }
  if (window.location.href.includes('vantage')) {
    channel = 'vantage'
  }
  if (window.location.href.includes('helloyou')) {
    channel = 'helloyou'
  }
  if (window.location.href.includes('teams')) {
    channel = 'teams'
  }
  if (window.location.href.includes('sitelecom')) {
    channel = 'sitelecom'
  }
  if (window.location.href.includes('webinpage')) {
    channel = 'webinpage'
  }
  // else if (window.location.href.includes('app')) {
  //   channel = 'app'
  // }
  if (params.channel) {
    channel = params.channel
  }

  return channel
}

// 获取设备
const getDevice = (params:LooseObject): string => {
  let device = ''
  if (params.device) { // 如果url携带device参数
    if (params.device.toLowerCase() === 'mobile') { // 如果device是mobile
      device = 'mobile_phone'
    } else if (params.device.toLowerCase() === 'tablet') { // 如果device是tablet
      device = 'mobile_pad'
    } else {
      device = 'mobile_phone'
    }
  } else { // 如果url没有携带device参数
    if (isMobile()) { // 如果是移动端
      device = 'mobile_phone'
    } else { // 如果是pc端
      device = 'pc_computer'
    }
  }

  return device
}

// 获取页面配置数据
const getInitConfig = (callback: () => void) => {
  const urlParams = store.getters['global/params']
  const params:InitConfigQueryParams = {
    timestamp: Date.parse(String(new Date())),
    requestId: '',
    params: {
      channel: store.getters['global/channel'],
      geo: store.getters['global/geo'],
      language: store.getters['global/language'],
      country: store.getters['global/country'],
      brand: store.getters['global/brand'] ? store.getters['global/brand'] : '',
      device: urlParams.device ? urlParams.device : '',
      scenarioCode: store.getters['global/params'].scenarioCode || store.getters['global/scenarioCode'] || '',
      domainName: window.location.hostname
    },
    data: urlParams.data ? urlParams.data : ''
  }
  apiGetInitConfigQuery(params)
    .then((res) => {
      const data = res.data.data
      loginADFS(data)
      // 提交所有页面配置数据
      store.commit('global/SET_PAGE_CONFIG', data)
      // 提交场景码
      store.commit('global/SET_SCENARIO_CODE', data.scenarioConfig.scenarioCode)
      // 提交场景name
      store.commit('global/SET_SCENARIO_NAME', data.scenarioConfig.scenarioName)
      if (urlParams.device) {
        if (urlParams.device.toLowerCase() === 'mobile') {
          store.commit('global/SET_USER_AGENT', 'mobile')
        } else {
          store.commit('global/SET_USER_AGENT', 'pc')
          // window.userDevice = 'pad'
        }
      } else {
        if (isMobile() || window.location.href.includes('webinpage') || urlParams.sourcePage === 'smallprog' || urlParams.sourcePage === 'paasprogram') {
          store.commit('global/SET_USER_AGENT', 'mobile')
        } else {
          store.commit('global/SET_USER_AGENT', 'pc')
        }
      }
      callback()
    })
}

// 字符串按照特定字符转换成对象
export function stringTransformObj (str:string, symbol?:string):LooseObject {
  const obj:LooseObject = {}
  let name, value
  const arr = str.split((symbol || '&'))
  for (const val of arr) {
    const index = val.indexOf('=')
    if (index > 0) {
      name = val.substring(0, index)
      value = val.slice(index + 1)
      obj[name] = value
    }
  }
  return obj
}

// url参数解析
export const paramsParse = ():LooseObject => {
  // 截取URL中？后面的字符串
  const str:string = window.location.href.slice(window.location.href.indexOf('?') + 1)
  const strDecodeRes: string = decodeURIComponent(str)
  // 将其进行URLdecode解码后注入解析函数
  const params:LooseObject = stringTransformObj(strDecodeRes)
  // 判断解析过后的字面量中是否包含data属性
  if (params.data) {
  /**
   * 包含data属性，其中moli lena xiaoyi 等典型三种入参编码格式有区别。
   * 需进行urlDecode解码->base64解码->urlDecode解码
   */
    const urlDecodeResult:string = decodeURIComponent(params.data)
    const base64DecodeResult:string = decode(urlDecodeResult)
    const nextUrlDecodeResult:string = decodeURIComponent(base64DecodeResult)

    // 解码之后的data属性的值有两种类型
    if (JSON.stringify(stringTransformObj(nextUrlDecodeResult)) === '{}') {
    // object：直接合并
      Object.assign(params, JSON.parse(nextUrlDecodeResult))
    } else {
    // string：需再次进行间隔符号解析直到解析为object，然后合并
      Object.assign(params, stringTransformObj(nextUrlDecodeResult))
    }
  }
  return params
}

// 是否为移动端
export const isMobile = (params = {device: ''}):boolean => {
  const userAgenInfo:string = navigator.userAgent
  const Agents: Array<string> = ['Android', 'iPhone', 'SymbianOS', 'iPad', 'iPod', 'ios']
  let flag = false
  // 如果是device是tablet
  if (params.device === 'Tablet' || window.location.href.includes('tablet')) {
    flag = false
  } else {
    for (const value of Agents) {
      if (userAgenInfo.indexOf(value) > 0) {
        flag = true
        break
      }
    }
  }

  return flag
}

// 动态添加meta标签（为了适配移动端和pc端的）
export const appendElement = (params:any):void => {
  // 创建变量
  const userAgent:boolean = isMobile(params)
  // 判断渠道，设置对应的脚本和标签
  if (userAgent || window.location.href.includes('webinpage') || params.sourcePage === 'smallprog' || params.sourcePage === 'paasprogram') {
    // 添加 rem 脚本
    (function (doc, win) {
      const docEl:HTMLElement = doc.documentElement
      const resizeEvt:string = 'orientationchange' in window ? 'orientationchange' : 'resize'
      const recalc = function ():void {
        const clientWidth:number = docEl.clientWidth
        if (!clientWidth) {
          return
        }
        docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
      }
      if (!doc.addEventListener) {
        return
      }
      win.addEventListener(resizeEvt, recalc, false)
      doc.addEventListener('DOMContentLoaded', recalc, false)
    })(document, window)

    // 获取head
    const head = document.getElementsByTagName('head')
    // 动态创建meta
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
    head[0].appendChild(meta)
  } else {
    // 获取head
    const head = document.getElementsByTagName('head')
    // 动态创建meta
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = 'width=device-width,initial-scale=1.0'
    head[0].appendChild(meta)
  }
}

// 解析参数完成
export const onresolveparamsed = (callback: () => void) => {
  const loadingInstance = ElLoading.service({
    text: 'loading....'
  })
  // 获取、提交浏览器参数
  const params = paramsParse()

  store.commit('global/SET_PARAMS', params)
  // 动态添加适配pc或mobile的meat标签
  appendElement(params)
  // 获取、提交渠道
  const channel:string = getChannel(params)
  store.commit('global/SET_CHANNEL', channel)
  // 获取、提交用户设备
  const device:string = getDevice(params)
  store.commit('global/SET_DEVICE', device)
  // 获取url中的标识
  const locationHref = window.location.href
  // 判断是否为第三方渠道webview和智联引导页
  if (locationHref.indexOf('webview') !== -1 || locationHref.indexOf('guide') !== -1) {
    // 获取、提交第三方渠道webview
    store.commit('global/SET_USER_AGENT', locationHref.indexOf('guide') !== -1 ? 'guide' : 'webview')
    // 提交语言
    store.commit('global/SET_LANGUAGE', params.language)
    // 提交场景码
    store.commit('global/SET_SCENARIO_CODE', params.scenarioCode)
    // 提交项目名称
    store.commit('global/SET_PROJECT_NAME', params.projectName)
    // 提交geo
    store.commit('global/SET_GEO', params.geo)
    callback()
    loadingInstance.close()
  } else {
    console.log('channel', channel)
    // 请求参数
    const configQueryParams = {
      timestamp: Date.parse(String(new Date())),
      requestId: '',
      domainName: window.location.hostname,
      country: params.country || '',
      channel: store.getters['global/channel'] || 'error',
      data: params.data || '',
      scenarioCode: params.scenarioCode || store.getters['global/scenarioCode'] || '',
      urlParams: store.getters['global/params'] || {}
    }
    // 请求configQuery接口
    apiGetConfigQuery(configQueryParams)
      .then((res) => {
        // 响应结果
        const data = res.data.data
        // 提交项目名称
        store.commit('global/SET_PROJECT_NAME', data.projectName.toLowerCase())
        // 提交userInfo
        if (data.loginInfo && data.loginInfo.isLogin) {
          store.commit('login/SET_USER_INFO', data.loginInfo)
        }
        // 缓存userID和orgID（智联项目）
        if (data.message === '') {
          setCookie('userId', data.userID)
          setCookie('orgID', data.orgID)
          localStorage.setItem('userId', data.userID)
          localStorage.setItem('orgID', data.orgID)
        }
        if (data.mfHost) {
          setCookie('mfHost', data.mfHost)
          localStorage.setItem('mfHost', data.mfHost)
          setCookie('mfSocketHost', data.mfSocketHost)
          localStorage.setItem('mfSocketHost', data.mfSocketHost)
        }
        if (data.loginInfo.lenovoId) {
          setCookie('userId', data.loginInfo.lenovoId)
          localStorage.setItem('userId', data.loginInfo.lenovoId)
          setCookie('lenovo_id', data.loginInfo.lenovoId)
          localStorage.setItem('lenovo_id', data.loginInfo.lenovoId)
          setCookie('telephone', data.loginInfo.telephone)
          localStorage.setItem('telephone', data.loginInfo.telephone)
        }
        // 项目名称
        const projectName:string = data.projectName.toLowerCase()
        // geo简码
        const geo:string = data.geo.toLowerCase()
        // 配置文件前缀
        const configFileName:string = projectName + '-' + geo
        // 按照文件前缀请求本地配置文件 application-properties
        apiGetApplicationPropterty(configFileName).then((result) => {
        // 解构本地默认配置
          const {
            language: defaultLanguage,
            country: defaultCountry,
            geo: defaultGeo,
            countryList: defaultCountryList
          } = result.data
          // 获取映射数据
          apiGetLocalfiles(`/${window.botV2GlobalProperties.BASE_PATH}/json/common/maping.json`).then((value) => {
          // 结构language映射表和country映射表
            const { languageMap, countryMap, geoMap, userInfoParameMap } = value.data
            // 设置 language
            const finalLanguage:string = languageMap[decodeURIComponent(params.language as any)] ? languageMap[decodeURIComponent(params.language as any)] : defaultLanguage.name
            store.commit('global/SET_LANGUAGE', finalLanguage)
            // 设置 country
            const finalCountry:string = countryMap[decodeURIComponent(params.country as any)] ? countryMap[decodeURIComponent(params.country as any)] : defaultCountry.name
            store.commit('global/SET_COUNTRY', finalCountry)
            // 设置 countryList
            const finalCountryList:string = countryMap[decodeURIComponent(params.countryList as any)] ? countryMap[decodeURIComponent(params.countryList as any)] : defaultCountryList
            store.commit('global/SET_COUNTRY_LIST', finalCountryList)
            // 设置 geo
            const finalGeo:string = geoMap.geoMapData[finalCountry] ? geoMap.geoMapData[finalCountry] : defaultGeo.name
            store.commit('global/SET_GEO', finalGeo)
            // 设置 userInfo
            const userInfo:LooseObject = {}
            // 设置 accessInfo
            const paramsDeleted = JSON.parse(JSON.stringify(params))
            userInfoParameMap.map((val: string[]) => {
            // 匹配url中携带的参数的值
              const mapingResult = params[val[1]]
              // 如果存在，代表需要被映射进userInfo
              if (mapingResult) {
                const key:string = val[0]
                // key等于country的使用finalCountry，其他的使用当前结构映射结果
                // userInfo[key] = (key === 'country' ? finalCountry : mapingResult)
                if (key === 'country') {
                  userInfo[key] = finalCountry
                } else {
                  userInfo[key] = mapingResult
                }
              }
              // 在paramsDeleted中逐一删除所有包含的key的选项（剩余的就是accessInfo）
              if (paramsDeleted[val[1]]) {
                delete paramsDeleted[val[1]]
              }
            })
            // 提交userInfo
            store.commit('global/SET_USER_INFO', userInfo)
            // 在paramsDeleted对象中删除language 和 geo
            delete paramsDeleted['language']
            delete paramsDeleted['geo']
            // 保存accessInfo
            store.commit('global/SET_ACCESS_INFO', paramsDeleted)
            loadingInstance.close()
            // 执行结束回调
            getInitConfig(callback)
          }).catch(() => {
            ElMessage.error('service error')
          })
          // 保存本地配置
          store.commit('global/SET_APPLICATION_PROPERTIES', res.data)
        }).catch(() => {
          ElMessage.error('service error')
        })
      })
      .catch((error) => {
        ElMessage.error('service error')
        console.log(error)
      })
  }
}

